{
    "warning": "警告！",
    "message": "不明なコードを入力または貼り付けないでください。\nこのコンソールを使用すると、攻撃者がSelf-XSSという攻撃を使用してあなたになりすまし、情報を盗むことができます。"
}
